import { PartnersInputs } from './Partners';

export const partnersHelper = (node: any): PartnersInputs => {
    return {
        title: node.field_component_title,
        partners: node.relationships?.field_partners.map((partner) => {
            return {
                logo: partner.relationships.field_partner_logo,
                alt: partner.field_partner_logo.alt,
                title: partner.field_partner_website.title,
                id: partner.id,
                uri: partner.field_partner_website.uri,
            };
        }),
    };
};
